function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { isArray, isFunction, isUndefined } from '@okee-uikit/react-utils';
import { Emitter } from '@okee-uikit/react-hooks';
import { TreeMapData, TreeMapState, TreeMapValue } from '../../../models/tree-map';
export var CASCADER_PANEL_HEIGHT = 232;
export var CASCADER_PANEL_COLUMN_TITLE_HEIGHT = 38;
export var CASCADER_PANEL_COLUMN_LIST_HEIGHT = CASCADER_PANEL_HEIGHT - CASCADER_PANEL_COLUMN_TITLE_HEIGHT - 2;
export var Cascader = function (_Emitter) {
  _inherits(Cascader, _Emitter);

  var _super = _createSuper(Cascader);

  function Cascader() {
    var _this;

    _classCallCheck(this, Cascader);

    _this = _super.call(this);
    _this.columnWidth = 200;
    _this.rowHeight = 34;
    _this.searchItemHeight = 34;
    _this.query = '';
    _this.activeId = '';
    _this.queries = [];
    _this.ignoreCase = false;
    _this.columnTitles = [];
    _this.initLoadingIds = [];

    _this.load = function () {
      return Promise.resolve([]);
    };

    _this.search = function (query, itemData) {
      var search = itemData.search;
      var value = JSON.stringify(itemData.value);

      if (_this.ignoreCase) {
        search = search.toLowerCase();
        value = value.toLowerCase();
        query = query.toLowerCase();
      }

      return search.indexOf(query) !== -1 || value.indexOf(query) !== -1;
    };

    _this.valueChange = function (value) {
      _this.emit('change', value, _this.getDisplayInfo());

      _this.emit('value-change');
    };

    _this.treeMapData = new TreeMapData(_this.getValueFromData, _this.getLabelFromData);
    _this.treeMapValue = new TreeMapValue(_this.treeMapData);

    _this.init();

    return _this;
  }

  _createClass(Cascader, [{
    key: "updateCascader",
    value: function updateCascader(options) {
      var _options$columnWidth = options.columnWidth,
          columnWidth = _options$columnWidth === void 0 ? 200 : _options$columnWidth,
          _options$rowHeight = options.rowHeight,
          rowHeight = _options$rowHeight === void 0 ? 34 : _options$rowHeight,
          _options$searchItemHe = options.searchItemHeight,
          searchItemHeight = _options$searchItemHe === void 0 ? 34 : _options$searchItemHe,
          _options$columnTitles = options.columnTitles,
          columnTitles = _options$columnTitles === void 0 ? [] : _options$columnTitles,
          _options$value = options.value,
          value = _options$value === void 0 ? [] : _options$value,
          particalCheck = options.particalCheck,
          disabled = options.disabled,
          datasource = options.datasource,
          showAll = options.showAll,
          multiple = options.multiple,
          independent = options.independent,
          readonly = options.readonly,
          association = options.association,
          spread = options.spread,
          checkStrategy = options.checkStrategy,
          _options$load = options.load,
          load = _options$load === void 0 ? function () {
        return Promise.resolve([]);
      } : _options$load,
          _options$ignoreCase = options.ignoreCase,
          ignoreCase = _options$ignoreCase === void 0 ? false : _options$ignoreCase,
          _options$search = options.search,
          search = _options$search === void 0 ? this.search : _options$search,
          scroll = options.scroll,
          bottomSlot = options.bottomSlot,
          loadMore = options.loadMore;
      var treeMapDataOptions = {
        readonly: readonly,
        disabled: disabled,
        datasource: datasource,
        showAll: showAll,
        multiple: multiple,
        independent: independent,
        checkStrategy: checkStrategy,
        association: association,
        spread: spread
      };
      var treeMapValueOptions = {
        value: value,
        particalCheck: particalCheck
      };
      this.columnWidth = columnWidth;
      this.rowHeight = rowHeight;
      this.searchItemHeight = searchItemHeight;
      this.load = load;
      this.search = search;
      this.ignoreCase = ignoreCase;
      this.columnTitles = columnTitles;
      this.scroll = scroll;
      this.bottomSlot = bottomSlot;
      this.loadMore = loadMore;

      var _this$treeMapData$upd = this.treeMapData.updateTreeMapDataOptions(treeMapDataOptions),
          _this$treeMapData$upd2 = _slicedToArray(_this$treeMapData$upd, 2),
          needUpdateDatasource = _this$treeMapData$upd2[0],
          needUpdateValue = _this$treeMapData$upd2[1];

      var needSetActiveId = this.treeMapValue.updateTreeMapValueOptions(treeMapValueOptions, needUpdateValue);

      if (needSetActiveId) {
        this.setActiveIdBySetValue(this.treeMapValue.getValue());
      }

      if (needUpdateDatasource) {
        this.emit('reset');
      }
    }
  }, {
    key: "multiple",
    get: function get() {
      return this.treeMapData.multiple;
    }
  }, {
    key: "independent",
    get: function get() {
      return this.treeMapData.independent;
    }
  }, {
    key: "setActiveId",
    value: function setActiveId(id) {
      var _this2 = this;

      if (this.activeId === id) {
        this.emit('item-unfold');
        return;
      }

      this.activeId = id;
      var map = this.treeMapData.getItemInfo(id);

      if (map.needLoad) {
        map.needLoad = false;
        map.loading = true;
        this.emit('data-loading', id);
        this.load(map).then(function (datasource) {
          var latestParentState = _this2.treeMapValue.getItemState(id);

          map.loading = false;
          map.children = datasource.map(function (item, index) {
            return _this2.treeMapData.createDataHashMap(item, map.id, map.level + 1, map.path.concat([index]));
          });
          map.isLeaf = false;

          _this2.treeMapValue.addLoadingItemState(map.children, latestParentState);

          _this2.treeMapValue.changeSourceData(datasource, map.path);

          if (!map.isLeaf && _this2.treeMapValue.getItemState(id) === TreeMapState.SELECTED) {
            _this2.treeMapValue.setItemState(id, TreeMapState.SELECTED, true);
          }

          _this2.emit('data-loading', id);
        }).catch(function (e) {
          console.error(e);
          map.loading = false;
          map.children = [];
          map.isLeaf = true;

          _this2.emit('data-loading', id);
        });
      }

      this.emit('active-change');
      setTimeout(function () {
        _this2.emit('item-unfold');
      }, 0);
    }
  }, {
    key: "setItemState",
    value: function setItemState(id, newState, filter) {
      var success = this.treeMapValue.setItemState(id, newState, undefined, undefined, filter);

      if (!success) {
        return;
      }

      if (this.treeMapData.multiple) {
        var state = this.getItemState(id);

        if (state === TreeMapState.SELECTED) {
          if (this.activeId == null) {
            this.setActiveId(id);
            return;
          }

          var item = this.getItemInfo(id);

          if (item.nodePath.indexOf(id) < 0) {
            this.setActiveId(id);
          }
        }
      } else {
        this.setActiveId(id);
      }
    }
  }, {
    key: "scrollBottomLoad",
    value: function scrollBottomLoad(id) {
      var _this3 = this;

      var map = this.treeMapData.getItemInfo(id);
      if (map.isLoadingMore || !map.hasMore) return;

      if (this.loadMore) {
        map.isLoadingMore = true;
        this.loadMore(this.getExtraInfoById(id)).then(function (dataSource) {
          var _a;

          var latestParentState = _this3.treeMapValue.getItemState(id);

          var data = dataSource;
          var hasMore = true;

          if (!isArray(dataSource)) {
            data = dataSource.data || [];
            hasMore = isUndefined(dataSource.hasMore) ? true : dataSource.hasMore;
          }

          var length = ((_a = map.children) === null || _a === void 0 ? void 0 : _a.length) || 0;
          var addedChildren = data.map(function (item, index) {
            var childIndex = length + index;
            return _this3.treeMapData.createDataHashMap(item, map.id, map.level + 1, map.path.concat([childIndex]));
          });

          _this3.treeMapValue.changeSourceData(data, map.path);

          _this3.treeMapValue.addLoadingItemState(addedChildren, latestParentState);

          map.children = (map.children || []).concat(addedChildren);
          map.hasMore = hasMore;
          map.isLoadingMore = false;

          _this3.emit('data-loading', map.nodePath[0]);
        });
      }
    }
  }, {
    key: "getExtraInfoById",
    value: function getExtraInfoById(id) {
      var _this$getItemInfo = this.getItemInfo(id),
          path = _this$getItemInfo.path,
          level = _this$getItemInfo.level,
          parentId = _this$getItemInfo.parentId,
          children = _this$getItemInfo.children;

      return {
        path: path,
        level: level,
        parent: parentId ? this.getItemInfo(parentId) : null,
        siblings: children || []
      };
    }
  }, {
    key: "getItemState",
    value: function getItemState(id) {
      return this.treeMapValue.getItemState(id);
    }
  }, {
    key: "getAvticeId",
    value: function getAvticeId() {
      return this.activeId;
    }
  }, {
    key: "getActiveIds",
    value: function getActiveIds() {
      var rootId = this.treeMapData.getRootId();

      if (!this.activeId || this.activeId === rootId) {
        return this.getItemInfo(rootId).isLeaf ? [] : [rootId];
      }

      var info = this.getItemInfo(this.activeId);
      return info ? info.nodePath || [] : [];
    }
  }, {
    key: "getRootId",
    value: function getRootId() {
      return this.treeMapData.getRootId();
    }
  }, {
    key: "setVisible",
    value: function setVisible(value) {
      this.emit('visible-change', value);
    }
  }, {
    key: "getDisplayInfo",
    value: function getDisplayInfo() {
      var _this4 = this;

      return this.treeMapValue.getSortedIdFromSelected().map(function (item) {
        return _this4.treeMapData.getItemInfo(item);
      });
    }
  }, {
    key: "getGroupDisplayInfo",
    value: function getGroupDisplayInfo() {
      var _this5 = this;

      var result = this.treeMapValue.getIdFromSelected().map(function (item) {
        return _this5.treeMapData.getItemInfo(item);
      });
      var map = [];
      result.forEach(function (item) {
        map[item.nodePath.length - 1] = map[item.nodePath.length - 1] || [];
        map[item.nodePath.length - 1].push(item);
      });
      var ret = [];

      for (var i = 0; i < map.length; i++) {
        if (map[i]) {
          ret.push({
            level: i - 1,
            list: map[i]
          });
        }
      }

      return ret;
    }
  }, {
    key: "getColumnTitle",
    value: function getColumnTitle(idx, parentId) {
      if (isFunction(this.columnTitles)) {
        var info = this.getItemInfo(parentId);
        return this.columnTitles(info);
      } else if (this.columnTitles.length === 0) {
        return null;
      }

      return this.columnTitles[idx];
    }
  }, {
    key: "setQuery",
    value: function setQuery(query) {
      var _this6 = this;

      var hashMap = this.treeMapData.getHashMap();
      var rootId = this.treeMapData.getRootId();
      this.query = query;
      this.queries = Object.keys(hashMap).filter(function (key) {
        return key !== rootId && _this6.search(_this6.query, hashMap[key]);
      });
      this.emit('query-change', this.queries);
    }
  }, {
    key: "getQueries",
    value: function getQueries() {
      return this.queries;
    }
  }, {
    key: "resetValue",
    value: function resetValue() {
      this.treeMapValue.resetValue();
    }
  }, {
    key: "clearSelected",
    value: function clearSelected() {
      this.treeMapValue.clearSelected();
    }
  }, {
    key: "getItemInfo",
    value: function getItemInfo(id) {
      return _objectSpread(_objectSpread({}, this.treeMapData.getItemInfo(id)), {}, {
        state: this.treeMapValue.getItemState(id)
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.activeId = '';
      this.queries = [];
      this.treeMapValue.removeListener('value-change', this.valueChange);
    }
  }, {
    key: "getValueFromData",
    value: function getValueFromData(data) {
      return data.value;
    }
  }, {
    key: "getLabelFromData",
    value: function getLabelFromData(data) {
      return data.label;
    }
  }, {
    key: "init",
    value: function init() {
      this.treeMapValue.addListener('value-change', this.valueChange);
    }
  }, {
    key: "setActiveIdBySetValue",
    value: function setActiveIdBySetValue(value) {
      if ((!this.activeId || this.getItemInfo(this.activeId).state == null) && value.length) {
        this.activeId = this.treeMapData.getIdByValue(value[value.length - 1]);
        this.emit('active-change');
        this.emit('item-unfold');
        return true;
      }

      return false;
    }
  }]);

  return Cascader;
}(Emitter);